import {
	initAesKey,
	rsaEncrypt
} from '@/utils/encryption/utils'
import Cache from '@/utils/cache'

const CACHE_KEY = 'ENCRYPTION_KEYS'

const state = () => ({
	publicKey: null, // RSA加密公匙
	aesKey: null, // AES加密密匙
	aesEncryptKey: null // AES密匙的RSA加密字符串
})

const mutations = {
	SET_PUBLICKEY(state, publicKey) {
		state.publicKey = publicKey
	},
	SET_AESKEY(state, aesKey) {
		state.aesKey = aesKey
	},
	SET_AESENCRYPTKEY(state, aesEncryptKey) {
		state.aesEncryptKey = aesEncryptKey
	}
}

const actions = {
	// 初始化请求，获取RSA公匙
	async initPublicKey({
		commit,
		state
	}) {
		let cache = null
		try {
			cache = Cache.get(CACHE_KEY)
		} catch (err) {
			console.warn('读取缓存失败，重新生成 AES Key 和公钥', err)
		}

		// 如果缓存存在且完整，则直接使用缓存
		if (cache && cache.publicKey && cache.aesKey && cache.aesEncryptKey) {
			commit('SET_PUBLICKEY', cache.publicKey)
			commit('SET_AESKEY', cache.aesKey)
			commit('SET_AESENCRYPTKEY', cache.aesEncryptKey)
			return {
				code: 1,
				data: cache
			}
		}

		// 缓存不存在或读取失败，重新生成
		const res = {
			code: 1,
			data: {
				key: "-----BEGIN PUBLIC KEY-----" +
					"MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA3UzhG9PzO9sHAQU0WH4s"+
					"aagORhGsUU1f+N5CICw6/dZ388zAcezQ4UsW9xnkfgNBsE9WBok9b9D+vMaTVIsb"+
					"Sejn4ZDNgvc5Eclx54/ab4fNUHcDCbFDcACKHBR4fHsLaieFxn3DIkVXSPEzZ6at"+
					"FWhgJCD3wJnkQx01h1fhVaAhuzmVAzkMQzjYkJAqP7/dIUd6+XH5DBA+C+1lHsPV"+
					"NbNDo5tctIhKtqIgkcjG6uNfggTNB3pMims6g+GybsbaOo0aKCFtSt8Nxd9mA3Lh"+
					"4SovbUBZNb8VR9z9VgiyPIYmAuLqKS/pc/AUvBXIsIxvyqe5kmJ+k+XBL5RNKTCO"+
					"jwIDAQAB"+
					"-----END PUBLIC KEY-----"
			}
		}

		if (res.code) {
			commit('SET_PUBLICKEY', res.data.key)

			const aesKey = initAesKey()
			commit('SET_AESKEY', aesKey)

			const aesEncryptKey = rsaEncrypt(aesKey, res.data.key)
			commit('SET_AESENCRYPTKEY', aesEncryptKey)

			// 缓存起来
			try {
				Cache.set(CACHE_KEY, {
					publicKey: res.data.key,
					aesKey,
					aesEncryptKey
				}, 3600 * 24 * 1)
			} catch (err) {
				console.warn('写入缓存失败', err)
			}
		}

		return res
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}